import React from "react";
import { Link } from "react-router-dom";

const FooterBrand = ({ tagline }) => (
  <div className="md:col-span-5">
    <Link to="/" className="flex items-center gap-3 mb-6">
      <div className="w-10 h-10 border border-[#C6A87C] flex items-center justify-center">
        <span className="font-serif text-xl text-[#C6A87C]">H</span>
      </div>
      <div>
        <div className="font-serif text-xl tracking-wide">HARD ROCK</div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#C6A87C]">Members</div>
      </div>
    </Link>
    <p className="text-sm text-[#A0AEC0] max-w-sm leading-relaxed">{tagline}</p>
  </div>
);

export default FooterBrand;
